import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stat-card',
  template: `
    <div class="stats-card">
      <div *ngFor="let stat of stats" class="stat-item">
        <div class="stat-value">
          <span class="stat-prefix">{{ stat.prefix || '' }}</span>
          {{ stat.value }}
          <span class="stat-unit">{{ stat.unit || '' }}</span>
          <span class="stat-suffix">{{ stat.suffix || '' }}</span>
        </div>
        <div class="stat-description">
          {{ stat.description }}
        </div>
      </div>
    </div>
  `,
  styles: [`
    .stats-card {
      background: #f5faff;
      border: 1px solid #dce9f9;
      border-radius: 8px;
      padding: 16px;
      width: 100%;
      max-width: 400px;
    }

    .stat-item {
      margin-bottom: 16px;
    }

    /* Responsive font size using clamp(min, preferred, max) */
    .stat-value {
      font-size: clamp(16px, 4vw, 30px);
      font-weight: bold;
      color: #0073e6;
      line-height: 1.2;
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
    }

    .stat-prefix, .stat-suffix {
      font-size: clamp(14px, 2.5vw, 20px);
      font-weight: normal;
      margin: 0 2px;
    }

    .stat-unit {
      font-size: clamp(16px, 3vw, 22px);
      font-weight: normal;
      margin-left: 2px;
    }

    .stat-description {
      font-size: clamp(12px, 2vw, 16px);
      color: #333;
      margin-top: 4px;
    }

    .stat-item:last-child {
      margin-bottom: 0;
    }
  `]
})
export class StatCardComponent {
  @Input() stats: {
    value: number | string;
    unit?: string;
    prefix?: string;
    suffix?: string;
    description: string;
  }[] = [];
}
